import React from "react";

const HealthCheck = (props) => {
  console.log(process.env);
  return <div>{process.env.COMMIT_HASH}</div>;
};

export default HealthCheck;
